var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('tr',{staticClass:"group-color-yet"},[_c('td'),_c('td',{attrs:{"colspan":"7"}},[_c('b',[_vm._v("Chưa có team")])])])
}]

export { render, staticRenderFns }